var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_550_1873)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 2H18V6H30V2Z",
    fill: "#0B7077"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.06 14.78L40.9 11.94C40.04 10.92 39.1 9.96 38.08 9.12L35.24 11.96C32.14 9.48 28.24 8 24 8C14.06 8 6 16.06 6 26C6 35.94 14.04 44 24 44C33.96 44 42 35.94 42 26C42 21.76 40.52 17.86 38.06 14.78ZM26 28H22V16H26V28Z",
    fill: "#0B7077"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_550_1873"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/Timer.2c2d6157f76aec9a5799d12c4a312a03.svg";
export { ForwardRef as ReactComponent };